import { API } from '../helpers/fetcher'
import { prepareMetadata } from '../hooks/useMetadata.js'
import { DataDog } from '../datadog/index.js'

export const authorizePayment = async (transactionDetails, payment) => {
  const {
    paymentMethodData: {
      tokenizationData: { token },
    },
  } = payment

  const { amount, overrideAmount, notes, metadata } = transactionDetails

  if (metadata === 'invalid') {
    DataDog.error(`Wrong format of metadata`)
    console.error(`Wrong format of metadata`)
  } else if (metadata === 'lengthError') {
    console.error('Metadata should be not greater than 100 characters')
  }

  const body = {
    googlePay: {
      encryptedPaymentData: window.btoa(token),
    },
    amount: overrideAmount || amount,
    notes,
    metadata: prepareMetadata(metadata),
    paymentUrl: window.location.href,
  }

  return API.post('v1/transaction/google-pay/authorise', body)
}
